import { useSearchParam } from "lib/@hooks/use-search-param"
import { useReference } from "lib/@hooks/use-reference"

// The schedule right-bar Tabs (id "ScheduleRightBar") run WITHOUT `searchParam`, so the active tab is
// driven by the persisted reference, not the URL — the URL `ScheduleRightBarTab` param is only set by
// the comment deep-link routes and is dropped by navigations like entering Tailor/edit mode. Reading
// the URL alone therefore misses the active tab in the edit view (and anywhere the param wasn't
// explicitly set). This resolves the active right-bar tab from either source so the share-link comment
// highlight/scroll gates work for internal reviewers, not just share-link recipients (who gate on the
// share id instead).
export function useScheduleRightBarTab() {
    const [urlTab] = useSearchParam("ScheduleRightBarTab", null)
    const [reference] = useReference({ ScheduleRightBarTab: null }, "tab-ScheduleRightBar-")
    return urlTab || reference?.ScheduleRightBarTab || null
}
